module.exports = __webpack_public_path__ + "static/media/illustrations.1015aa8c.png";